import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import './style.scss';

interface IProps {
  isCondoPage?: boolean;
}

export class SubmitRequestHeading extends Component<IProps> {
  render(): React.ReactNode {
    const { isCondoPage } = this.props;

    return (
      <div className="submit-request-heading-wrapper">
        <div className="submit-request-heading-wrapper__wrapper">
          <Link
            className={`submit-request-heading-wrapper__link ${isCondoPage ? 'condo' : ''}`}
            to={isCondoPage ? '/condo/deals' : '/all-inclusives'}
          >
            <FormattedMessage id="back" />
          </Link>
          <h1 className={`submit-request-heading-wrapper__heading ${isCondoPage ? 'condo' : ''}`}>
            <FormattedMessage id="submit.request" />
          </h1>
        </div>
      </div>
    );
  }
}
